module.exports = __webpack_public_path__ + "img/circelcard.d9f4b034.svg";